import * as React from "react";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import { Label, Input, Row, Col } from "reactstrap";

import {
  UserRole,
  CreateCompanyInput,
  Province,
  ReportStatus,
  Suburb,
  CreateReportMutation,
  CreateReportMutationVariables,
  CreateReportCategoryMutation,
  CreateReportCategoryMutationVariables,
  CreateReportTagMutation,
  CreateReportTagMutationVariables
} from "../../API";

import StyledButton from "../../Components/Styled/Button";
import Card from "../../Components/Styled/Card";

import { Error } from "../../CustomTypes";
import { getUsersCompany } from "src/graphql/custom-queries";
import { getUserId, formatDropdown } from "src/Utils/Helpers";
import styled from "styled-components";
import PageLoader from "src/Components/PageLoader";

import { ToastNotificationType } from "../../CustomTypes";

import { withToastManager } from "react-toast-notifications";
import Container from "reactstrap/lib/Container";
import { Colors } from "src/Themes";
import Select from "react-select";
import BackendWrapper from "src/Components/Layouts/BackendWrapper";
import ErrorMessage from "src/Components/Styled/ErrorMessage";
import {
  createReport,
  createReportCategory,
  createReportTag
} from "src/graphql/mutations";
import { listCategorys, listTags, listReports } from "src/graphql/queries";
import { Route } from "react-router";
import { TableConsts } from "src/Utils/Consts";
import Loader from "src/Components/Loader";
import Link from "../../Components/Styled/Link";

type SelectProvinceType = {
  value: Province;
  label: string;
};

type SelectSuburbType = {
  value: Suburb;
  label: string;
};

type SelectBoolean = {
  value: boolean;
  label: string;
};
type SelectType = {
  value: string;
  label: string;
};

type Props = {
  roles?: UserRole[];
  companyData?: CreateCompanyInput | null;
  toastManager?: ToastNotificationType;
  location: { [key: string]: any }; // object with any amount and types of params
};

type State = {
  loading: boolean;
  error: Error;
  readOnly: boolean;
  modal: boolean;
  companyData: any;
  name: string;
  publisedDate: string;
  description: string;
  price: string;
  documentLocation: string;
  maxDownloads: string;
  downloadable: boolean;
  status: ReportStatus;
  province: Province;
  suburb: Suburb;
  city: string;
  paidOrFree: boolean;
  reportDetails: string;
  coverImageUrl: string;
  documentResourceUrl: string;
  tags: any; // CreateReportTagInput
  categories: any; // CreateReportCategoryInput
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  justify-content: flex-end;
  align-items: flex-end;
`;

class AddReport extends React.Component<Props, State> {
  state: State = {
    loading: false,
    error: null,
    readOnly: true,
    modal: false,
    companyData: {},
    name: "",
    publisedDate: "",
    description: "",
    price: "",
    documentLocation: "test",
    maxDownloads: "",
    downloadable: false,
    status: ReportStatus.DRAFT,
    province: Province.GAUTENG,
    suburb: Suburb.SUBURB_ONE,
    city: "",
    paidOrFree: true,
    reportDetails: "",
    coverImageUrl: "",
    documentResourceUrl: "",
    tags: "",
    categories: ""
  };

  /** Error */
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  // Select company province
  selectCompanyProvince = (province: SelectProvinceType): void => {
    this.setState({ province: province.value });
  };
  // Select company province
  selectSuburb = (suburb: SelectSuburbType): void => {
    this.setState({ suburb: suburb.value });
  };

  selectBoolean = (paifOrFree: SelectBoolean): void => {
    this.setState({ paidOrFree: paifOrFree.value });
  };

  formatList = (list: Suburb | Province | any) => {
    return Object.keys(list).map((item: string) => {
      return formatDropdown(item);
    });
  };

  openEdit = (data: object) => {
    this.setState({ modal: true, companyData: data });
  };

  /** Close modal */
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  handleCategoryChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ categories: e });
  };

  handleTagChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ tags: e });
  };

  // Handle change
  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "name":
        this.setState({ name: value });
        break;
      case "publisedDate":
        this.setState({ publisedDate: value });
        break;
      case "description":
        this.setState({ description: value });
        break;
      case "reportDetails":
        this.setState({ reportDetails: value });
        break;
      case "city":
        this.setState({ city: value });
        break;
      case "price":
        this.setState({ price: value });
        break;
      case "maxDownloads":
        this.setState({ maxDownloads: value });
        break;
      case "documentResourceUrl":
        this.setState({ documentResourceUrl: value });
        break;
      case "coverImageUrl":
        this.setState({ coverImageUrl: value });
        break;
      default:
        break;
    }
  };

  /** Create a new tag */
  createReport = async (
    createReportMutation: ({}) => Promise<any>,
    createReportCategoryMutation: ({}) => Promise<any>,
    createTagMutation: ({}) => Promise<any>,
    status: ReportStatus,
    history: any
  ) => {
    const {
      name,
      publisedDate,
      description,
      price,
      documentLocation,
      maxDownloads,
      downloadable,
      province,
      suburb,
      city,
      paidOrFree,
      reportDetails,
      coverImageUrl,
      documentResourceUrl
    } = this.state;

    // create the tag in dynamodb
    createReportMutation({
      variables: {
        input: {
          name,
          publisedDate,
          description,
          price,
          documentLocation,
          maxDownloads: maxDownloads !== "" ? maxDownloads : "unlimited",
          downloadable,
          status,
          province,
          suburb,
          city,
          paidOrFree,
          reportDetails,
          coverImageUrl,
          documentResourceUrl
        }
      },
      refetchQueries: [
        {
          query: gql(listReports),
          variables: { limit: TableConsts.limit }
        }
      ]
    })
      .then((response: any) => {
        /**
         * Loop through Categories selected and run the createReportCategory for each,
         * after that loop successfully completes, do the same with Tags and run the createReportTag mutation.
         */
        this.loopCategories(
          createReportCategoryMutation,
          createTagMutation,
          response.data.createReport.id,
          history
        );
      })
      .catch((err: any) => {
        this.setError(err.message);
      });
  };

  loopCategories = async (
    createReportCategoryMutation: ({}) => Promise<any>,
    createTagMutation: ({}) => Promise<any>,
    reportId: string,
    history: any
  ) => {
    const { categories } = this.state;
    categories.map(async (item: SelectType) => {
      return await createReportCategoryMutation({
        variables: {
          input: {
            reportCategoryCategoryId: item.value,
            reportCategoryReportId: reportId
          }
        }
      })
        .then((response: any) => {
          this.loopTags(createTagMutation, reportId, history);
        })
        .catch((err: any) => {
          this.setError(err.message);
        });
    });
  };

  loopTags = async (
    createTagMutation: ({}) => Promise<any>,
    reportId: string,
    history: any
  ) => {
    const { tags } = this.state;
    await Promise.all(
      tags.map(async (item: SelectType) => {
        return await createTagMutation({
          variables: {
            input: {
              reportTagTagId: item.value,
              reportTagReportId: reportId
            }
          },
          refetchQueries: [
            {
              query: gql(listReports),
              variables: { limit: TableConsts.limit }
            }
          ]
        }).catch((err: any) => {
          this.setError(err.message);
        });
      })
    );
    // NAV TO LIST REPORT SCREEN.
    history.push("/admin-reports");
  };

  returnFormFields = () => {
    const {
      name,
      publisedDate,
      description,
      price,
      maxDownloads,
      province,
      suburb,
      city,
      paidOrFree,
      reportDetails,
      coverImageUrl,
      documentResourceUrl,
      tags,
      categories,
      error
    } = this.state;

    const paidOrFreeOptions = [
      {
        value: true,
        label: "Paid"
      },
      {
        value: false,
        label: "Free"
      }
    ];

    return (
      <React.Fragment>
        <Card width="100%">
          <Container>
            <Row>
              <HeaderContainer>
                <h2>Create Report</h2>
              </HeaderContainer>
            </Row>
            <Row>
              <Col sm={6}>
                <Label for="name">Name</Label>
                <Input
                  type="text"
                  name="name"
                  value={name}
                  id="name"
                  placeholder="Name"
                  onChange={e => this.onChange(e)}
                />
              </Col>
              <Col sm={6}>
                <Label for="publisedDate">Publised Date</Label>
                <Input
                  type="date"
                  name="publisedDate"
                  value={publisedDate}
                  id="publisedDate"
                  placeholder="publised date"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Query query={gql(listCategorys)}>
                {({ loading, data }) => {
                  if (loading) {
                    return <PageLoader />;
                  }
                  if (!loading && data) {
                    const categoriesList = data.listCategorys.items.map(
                      (cat: any) => ({
                        value: cat.id,
                        label: cat.name
                      })
                    );
                    return (
                      <Col sm={true}>
                        <Label>Category</Label>
                        <Select
                          options={categoriesList}
                          onChange={this.handleCategoryChange}
                          value={categories}
                          isSearchable={true}
                          isMulti={true}
                          placeholder=""
                          className="select-styling"
                        />
                      </Col>
                    );
                  } else {
                    return <div>There has been an error loading filters</div>;
                  }
                }}
              </Query>
            </Row>
            <br />
            <Row>
              <Query query={gql(listTags)}>
                {({ loading, data }) => {
                  if (loading) {
                    return <PageLoader />;
                  }
                  if (!loading && data) {
                    const tagsList = data.listTags.items.map((cat: any) => ({
                      value: cat.id,
                      label: cat.name
                    }));
                    return (
                      <Col sm={true}>
                        <Label>Keyword Tags</Label>
                        <Select
                          options={tagsList}
                          onChange={this.handleTagChange}
                          value={tags}
                          isSearchable={true}
                          isMulti={true}
                          placeholder=""
                          className="select-styling"
                        />
                      </Col>
                    );
                  } else {
                    return <div>There has been an error loading filters</div>;
                  }
                }}
              </Query>
              {/* <Col sm={true}>
                <Label for="tags">Keyword Tags</Label>
                <Input
                  type="text"
                  name="tags"
                  value={tags}
                  id="tags"
                  placeholder="tags"
                  onChange={e => this.onChange(e)}
                />
              </Col> */}
            </Row>
            <br />
            <Row>
              <Col sm={true}>
                <hr />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={true}>
                <Label for="description">Description</Label>
                <Input
                  type="textarea"
                  name="description"
                  value={description}
                  id="description"
                  placeholder="description"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={true}>
                <Label for="reportDetails">Report Details</Label>
                <Input
                  type="textarea"
                  name="reportDetails"
                  value={reportDetails}
                  id="reportDetails"
                  placeholder="reportDetails"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={true}>
                <hr />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={6}>
                <Label>Province</Label>
                <Select
                  options={this.formatList(Province)}
                  onChange={this.selectCompanyProvince}
                  value={formatDropdown(province)}
                  isSearchable={true}
                  placeholder=""
                  className="select-styling"
                />
              </Col>
              <Col sm={6}>
                <Label for="city">City</Label>
                <Input
                  type="text"
                  name="city"
                  value={city}
                  id="city"
                  placeholder="city"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={6}>
                <Label>Suburb</Label>
                <Select
                  options={this.formatList(Suburb)}
                  onChange={this.selectSuburb}
                  value={formatDropdown(suburb)}
                  isSearchable={true}
                  placeholder=""
                  className="select-styling"
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={true}>
                <hr />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={6}>
                <Label>Paid or Free</Label>
                <Select
                  options={paidOrFreeOptions}
                  onChange={this.selectBoolean}
                  value={
                    paidOrFree
                      ? { value: true, label: "Paid" }
                      : { value: false, label: "Free" }
                  }
                  placeholder=""
                  className="select-styling"
                />
              </Col>
              <Col sm={6}>
                <Label for="price">Price (incl. VAT)</Label>
                <Input
                  type="number"
                  name="price"
                  value={price}
                  id="price"
                  placeholder="price"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={6}>
                <Label for="maxDownloads">Maximum downloads allowed</Label>
                <Input
                  type="text"
                  name="maxDownloads"
                  value={maxDownloads}
                  id="maxDownloads"
                  placeholder="maxDownloads"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={6}>
                <Label for="documentResourceUrl">Upload document</Label>
                <Input
                  type="file"
                  name="documentResourceUrl"
                  value={documentResourceUrl}
                  id="documentResourceUrl"
                  placeholder="Name"
                  onChange={e => this.onChange(e)}
                />
              </Col>
              <Col sm={6}>
                <Label for="coverImageUrl">Upload cover image</Label>
                <Input
                  type="file"
                  name="coverImageUrl"
                  value={coverImageUrl}
                  id="coverImageUrl"
                  placeholder="coverImageUrl"
                  onChange={e => this.onChange(e)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={true}>
                <hr />
              </Col>
            </Row>
            <br />
            <Mutation<CreateReportMutation, CreateReportMutationVariables>
              mutation={gql(createReport)}
            >
              {(createReportMutation, { loading: createReportLoading }) => (
                <Mutation<
                  CreateReportCategoryMutation,
                  CreateReportCategoryMutationVariables
                >
                  mutation={gql(createReportCategory)}
                >
                  {(
                    createReportCategoryMutation,
                    { loading: createCategoryLoading }
                  ) => (
                    <Mutation<
                      CreateReportTagMutation,
                      CreateReportTagMutationVariables
                    >
                      mutation={gql(createReportTag)}
                    >
                      {(
                        createReportTagMutation,
                        { loading: createTagLoading }
                      ) => (
                        <Route
                          render={({ history }) => (
                            <React.Fragment>
                              {createReportLoading ||
                              createCategoryLoading ||
                              createTagLoading ? (
                                <Loader color={Colors.primary} />
                              ) : (
                                <Row>
                                  <Col sm={2}>
                                    <StyledButton
                                      type="button"
                                      label="Draft"
                                      onClick={() =>
                                        this.createReport(
                                          createReportMutation,
                                          createReportCategoryMutation,
                                          createReportTagMutation,
                                          ReportStatus.DRAFT,
                                          history
                                        )
                                      }
                                      width="120px"
                                      color={Colors.coal}
                                      background={Colors.background}
                                    />
                                  </Col>
                                  <Col sm={2}>
                                    <StyledButton
                                      type="button"
                                      label="Publish"
                                      onClick={() =>
                                        this.createReport(
                                          createReportMutation,
                                          createReportCategoryMutation,
                                          createReportTagMutation,
                                          ReportStatus.PUBLISHED,
                                          history
                                        )
                                      }
                                      width="120px"
                                      color={Colors.coal}
                                      background={Colors.background}
                                    />
                                  </Col>
                                  <Col sm={2}>
                                    <Link
                                      to={{
                                        pathname: "/admin-reports"
                                      }}
                                      label={
                                        <StyledButton
                                          type="button"
                                          label="Cancel"
                                          width="120px"
                                          color={Colors.coal}
                                          background={Colors.background}
                                        />
                                      }
                                    />
                                  </Col>
                                </Row>
                              )}
                            </React.Fragment>
                          )}
                        />
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          </Container>
          <br />
          {error && <ErrorMessage errorMessage={error} />}
        </Card>
      </React.Fragment>
    );
  };

  render() {
    return (
      <BackendWrapper>
        <Query query={gql(getUsersCompany)} variables={{ id: getUserId() }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <PageLoader />;
            }
            if (error) {
              return <div>There was a problem loading your data</div>;
            }

            return this.returnFormFields();
          }}
        </Query>
      </BackendWrapper>
    );
  }
}

export default withToastManager(AddReport);



// WEBPACK FOOTER //
// ./src/Containers/Reports/AddReport.tsx